/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DoctorEncuestasControllerEliminarEncuesta$Params {

/**
 * UUID de la encuesta a eliminar
 */
  uuidEncuesta: string;
}

export function doctorEncuestasControllerEliminarEncuesta(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerEliminarEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerEliminarEncuesta.PATH, 'delete');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

doctorEncuestasControllerEliminarEncuesta.PATH = '/api/doctor-encuestas/eliminar-encuesta/{uuidEncuesta}';
